module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp3_3.06970027.png";